/**
 * GutenKit Login Script.
 */
class GutenKitLogin {
    /**
     * Constructor.
     */
    constructor() {
        this.capsWarning = null;
        this.passwordInput = null;
        this.init();
    }

    /**
     * Initialize the login script.
     */
    init() {
        this.capsWarning = document.getElementById( 'caps-warning' );
        this.passwordInput = document.getElementById( 'user_pass' );

        if ( null === this.capsWarning || null === this.passwordInput ) {
            setTimeout( () => this.init(), 100 );
            return;
        }

        this.onPageLoadEvents();
    }

    /**
     * Bind events on page load.
     */
    onPageLoadEvents() {
        // Hide the caps warning if visible, since we can't detect caps lock state without a keyboard event.
        if ( 'none' !== getComputedStyle( this.capsWarning ).display ) {
            this.capsWarning.style.display = 'none';
        }
    }
}

window.addEventListener( 'DOMContentLoaded', () => new GutenKitLogin() );

